import { Component, OnInit } from '@angular/core';
import { Comments } from '../../classes/blogs.interface';
import { Users } from '../../classes/users';
import { DoctorService } from '../../services/doctor.service';
import {ActivatedRoute, Router, Params } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../authentication/auth.service';
import {MatSnackBar} from '@angular/material';
@Component({
  selector: 'app-forumdetail',
  templateUrl: './forumdetail.component.html',
  styleUrls: ['./forumdetail.component.css']
})
export class ForumdetailComponent implements OnInit {
  bid: number;
  userid: any;
  userimgarray = [];
  usernamearray = [];
  forum: any;
  comment: any;
  user: any;
  totalcomment: number;
  message: any;
  userrole = 0;
  userStatus = 0;
  public loading = false;
  uid: any;
  mydata: any;
  msg: any;
  action; any;
  constructor(private doctorService: DoctorService, private route: ActivatedRoute,
  private commonService: CommonService, private authService: AuthService, public snackBar: MatSnackBar) {
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.bid = id;
       });
       const udata = this.commonService.getUserDataLocally();
       this.uid = udata.uid;
       this.getUserDetail()
   }

  ngOnInit() {
    this.loading = true;
    this.getBlogDetail();
    this.checkUserStatus();
    this.checkUserType();

  }
  getUserDetail() {
    this.loading = true;
    this.doctorService.getCommentedUserDetail(this.uid)
    .subscribe(
    (x) => {
      this.mydata = x;
      this.loading = false;
    });
  }
  checkUserStatus() {
    this.userStatus = this.commonService.checkUserStatus();
  }
  checkUserType() {
   this.userrole = this.authService.getRoleId();
}
  getBlogDetail() {
    this.doctorService.getBogDetail(this.bid)
    .subscribe(
      (x) => {
        this.loading = false;
        this.forum = x;
        this.getCommentsOnForum();
      });
  }
  getCommentsOnForum() {
    this.doctorService.getCommentsOnBlog(this.bid)
    .subscribe(
      (comment: Comments[]) => {
        this.comment = comment;
        this.totalcomment = this.comment.length;
        for (let i = 0 ; i < this.comment.length ; i++) {
          this.getCommentUserDetail(this.comment[i].user_id)
        }
      }
    );
  }
  getCommentUserDetail(uid) {
    this.doctorService.getCommentedUserDetail(uid)
    .subscribe(
    (x) => {
      this.user = x;
      this.usernamearray['id' + uid] = this.user[0].name;
      this.userimgarray['id' + uid] = this.user[0].image;
    });
  }
  uploadComments() {
    this.loading = true;
      this.doctorService.uploadCommentsOnForum(this.bid , this.uid , this.message)
      .subscribe(
        (x) => {
          this.loading = false;
          this.getCommentsOnForum();
          this.message = undefined;
          this.msg = 'Comment posted successfully';
          this.openSnackBar();
        });
    }
    openSnackBar() {
      this.snackBar.open(this.msg, this.action , {
        duration: 4000,
      });
    }
}
